module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.svg)
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-38e588db","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/SVGIcon.vue
// module id = 805
// module chunks = 0